// extracted by mini-css-extract-plugin
export default {"container":"nDoFR4OhvyAOmE0ztQXq","switch":"H5D3qxNtl95gaVtUQQQ6"};